import { OrderDirection } from '../types/misc'

export const APP_NAME = 'CPad'

/**
 @see https://date-fns.org/docs/format for date formats.
 */
export const DATE_FORMATS = {
  DAY_MONTH_YEAR: 'dd/LL/yyyy', // 05/03/2002
  DAY_MONTH_YEAR_TIME: 'dd/LL/yyyy, h:mm a', // 05/03/2002, 2:53 PM
}

export const EMAIL_ADDRESSES = {
  support: 'support@cpad.com',
}

export const LOCAL_STORAGE_KEYS = {
  isProgrammaticReload: 'isProgrammaticReload',
}

export const ORDER_DIRECTION: Record<OrderDirection, OrderDirection> = {
  asc: 'asc',
  desc: 'desc',
}

export const THEME_PALETTE = {
  disabled: '#d3d3d3',
}

export const TIP_TAP_EXTENSION = {
  link: 'link',
}

export const PRO_PLAN_COST = 0.1
